import React from 'react';
import { Autocomplete, IconButton, InputAdornment } from '@mui/material';
import { TextField, FormHelperText } from '@mui/material';

function RenderSimpleAutocomplete({ input, meta: { invalid, touched, error, active }, ...custom }) {
	return (
		<div>
		<Autocomplete
    className={custom.inputdata.validate && touched && invalid ? 'generic-form-autocomplete-error' : ''}
    multiple={custom.inputdata.multiple}
    id={custom.inputdata.id}
    name={custom.inputdata.name}
    options={custom.inputdata.options || []}
    getOptionLabel={(option) => custom.inputdata.getOptionLabel?.(option) ?? option.label ?? ''}
    isOptionEqualToValue={(option, value) => custom.inputdata.isOptionEqualToValue?.(option, value) ?? option.id === value?.id}
    defaultValue={custom.inputdata.options.find(o => o.id === custom.inputdata.initialvalue) || null}
    clearOnBlur={false}
    freeSolo={custom.inputdata?.freeSolo ?? false}
    disableCloseOnSelect={Boolean(custom.inputdata.readonly)}
    disabled={Boolean(custom.inputdata.readonly)}
    filterSelectedOptions
    onChange={(event, option) => {
        
        input.onChange(option || null);
        if (custom.inputdata.onSelect) custom.inputdata.onSelect(option);
    }}
    onInputChange={(event, value, reason) => {
        if (custom.inputdata.onInputChange) custom.inputdata.onInputChange(value, reason);
    }}
    renderInput={(params) => (
        <TextField
            {...params}
            label={custom.inputdata.label}
            error={touched && invalid && !active}
            helperText={touched && !active && error}
        />
    )}
/>
			<FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error"> {custom.inputdata.helperText}</FormHelperText>
		</div>
	);
}
export default RenderSimpleAutocomplete;
